<template>
  <div class="content">
    <el-tabs v-model="activeTab" @tab-click="onTabClick">
      <el-tab-pane :label="$t('subAccount.tabRole')" name="role">
        <role-list ref="roleList" @go-accounts="goAccounts" />
      </el-tab-pane>
      <el-tab-pane :label="$t('subAccount.tabAccount')" name="account">
        <account-list ref="accountList" :role-id="roleFilterId" :roles="roles" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RoleList from '@/views/abroad/components/ssp/subAccount/RoleList'
import AccountList from '@/views/abroad/components/ssp/subAccount/AccountList'

export default {
  name: 'SubAccountPage',
  components: { RoleList, AccountList },
  data() {
    const q = this.$route.query || {}
    return {
      // tab 和角色筛选都记在地址栏里：从角色页跳过来、或者刷新页面，落回来的还是同一个视图
      activeTab: q.tab === 'account' ? 'account' : 'role',
      roleFilterId: q.role_id ? Number(q.role_id) : null,
      roles: []
    }
  },
  watch: {
    activeTab() {
      this.loadTab()
    }
  },
  mounted() {
    this.loadTab()
  },
  methods: {
    // 切到哪个 tab 就拉哪个 tab 的数据，另一个 tab 里改过什么，切回来拿到的就是新的
    loadTab() {
      if (this.activeTab === 'account') {
        this.loadRoles()
        this.$refs.accountList.getList()
      } else {
        this.$refs.roleList.getRoleList()
      }
    },
    // 账号弹窗的角色下拉、账号列表的角色筛选都要全量角色，技术方案里没有不分页的
    // 接口，先借 role/list 一次取够 —— 角色是主账号手工建的，量级很小
    loadRoles() {
      this.__postData('roleList', { page: 1, page_size: 999 }, res => {
        if (res && res.code == 1) {
          this.$message.error(res.msg)
          return
        }
        this.roles = (res && res.list) || []
      }, errmsg => {
        this.$message.error(errmsg)
      })
    },
    syncQuery() {
      const next = { tab: this.activeTab }
      if (this.activeTab === 'account' && this.roleFilterId) next.role_id = String(this.roleFilterId)
      const cur = this.$route.query || {}
      if (cur.tab === next.tab && (cur.role_id || '') === (next.role_id || '')) return
      this.$router.replace({ path: this.$route.path, query: next }).catch(() => {})
    },
    onTabClick() {
      // 手动切到账号页时不再带着角色筛选，它只属于「从角色页点账号数」那一次跳转
      if (this.activeTab === 'role') this.roleFilterId = null
      this.syncQuery()
    },
    // 角色页点「账号数」：切到账号页并按该角色筛一次（PRD 4.1.1 第 3.e 条）
    goAccounts(roleId, roleName) {
      this.roleFilterId = roleId
      // 先把筛选条件放进去，activeTab 的 watch 再去拉数据
      this.$refs.accountList.applyRoleId(roleId)
      this.activeTab = 'account'
      this.syncQuery()
      // 说一声筛选条件是自动带过来的。不提示的话，切过去看到的是一个已经
      // 筛过的列表，用户容易当成账号总共就这么几个
      if (roleName) {
        this.$message({ message: this.$t('subAccount.role.jumpedToAccounts', { name: roleName }) })
      }
    }
  }
}
</script>

